import DesignTypes from '~/constants/types/DesignTypes';
import FundraisingTypes from '~/constants/types/FundraisingTypes';
import TextTypes from '~/constants/types/TextTypes';
import CanvasTypes from '~/constants/types/CanvasTypes';
import {omit} from 'lodash';

import {
  getIcons,
  isDirty,
  getLastSavedCanvas,
  getCurrentCanvas
} from '~/selectors/CanvasSelectors';
import {getAnchorCompatibleStylesToArray} from '~/selectors/ProductSelectors';

import {isAnchorCompatibleWithCart} from '~/utils/combineDesignsEligibility';
import {metrics} from '~/vendor/metrics';

import {selectRecentlyAddedCartItems} from '~/slices/cartSlice';

const propsToExclude = [
  'rendered',
  'dragging',
  'textIsUpdating',
  'verifying',
  'sizeIsDirty',
  'naturalHeight',
  'naturalWidth',
  'wasSaved'
];

export default function hashing(state, action) {
  const iconValidationTypes = [
    TextTypes.VERIFY_DIMENSIONS,
    TextTypes.VERIFY_SUCCESS,
    CanvasTypes.ICON_RENDERED
  ];
  const isValidatingCleanCanvas =
    iconValidationTypes.includes(action.type) && !isDirty(state);

  const icons = getIcons(state).map(icon => {
    return omit(icon, propsToExclude);
  });
  const currentCanvasHashCode = icons.hashCode();
  const previousCanvasHashCode = getCurrentCanvas(state);
  const lastSavedCanvas = getLastSavedCanvas(state);
  const recentlyAddedCartItems = selectRecentlyAddedCartItems(state);
  if (
    lastSavedCanvas === previousCanvasHashCode &&
    previousCanvasHashCode !== currentCanvasHashCode &&
    recentlyAddedCartItems.length > 0
  ) {
    const anchorCompatibleStyles = getAnchorCompatibleStylesToArray(state);
    const cartItems = recentlyAddedCartItems;
    const isCompatible = isAnchorCompatibleWithCart(
      anchorCompatibleStyles,
      cartItems
    );

    if (isCompatible) {
      metrics.pageViewTag('/ndx/compatible/newdesign');
    }
  }

  const saveActionTypes = [
    DesignTypes.FETCH_SUCCESS,
    DesignTypes.SAVE_SUCCESS,
    FundraisingTypes.SAVE_SUCCESS,
    CanvasTypes.SHOW_DESIGN,
    TextTypes.UPDATE_FONT_CATEGORY
  ];
  const canvasChanges = {
    currentCanvas: currentCanvasHashCode
  };

  if (saveActionTypes.includes(action.type) || isValidatingCleanCanvas) {
    canvasChanges.lastSavedCanvas = currentCanvasHashCode;
  }

  const canvasState = state.canvas.present || state.canvas;

  return {
    ...state,
    canvas: {
      ...state.canvas,
      present: canvasState.merge(canvasChanges)
    }
  };
}
